import { renderHotelCard } from '@resources/js/components/hotel-card/helpers/renderHotelCard'
import Emitter from '@resources/js/helpers/Emitter'

export default class HotelCard extends Emitter {
	#hotel
	#template
	#renderFunction
	#cardElement
	#mainBtnElement

	constructor(
		hotel,
		{ hotelTemplateElement, renderFunction = renderHotelCard } = {}
	) {
		super()
		this.#hotel = hotel
		this.#template = hotelTemplateElement
		this.#renderFunction = renderFunction
		this.#cardElement = this.#renderHotelCard()

		this.#mainBtnElement = this.#cardElement.querySelector('.js-main-btn')

		this.#initEvents()
	}

	#renderHotelCard() {
		return this.#renderFunction(this.#hotel, this.#template)
	}

	get element() {
		return this.#cardElement
	}

	#initEvents() {
		this.#mainBtnElement.addEventListener('click', () => {
			this.emit('main-btn-click')
		})
	}
}
